import { Button, Flex, Form, Input, Typography } from 'antd'
import {
  HELP_TEXT_GENERAL,
  HELP_TEXT_PERMISSIONS,
} from 'src/pages/budget/budgetCategories/const'
import {
  closeModalArticle,
  submitAddArticle,
  submitUpdateArticle,
} from 'src/pages/budget/budgetCategories/model'

import { ArticleType } from 'src/pages/budget/types'
import { ItemSelectUsers } from 'src/pages/budget/components/itemSelectUsers'
import { useUsers } from 'src/pages/budget/hook'
import { REQUIRED_FIELD } from 'src/pages/budget/const'
import { UiText } from 'src/pages/budget/components'

type ArticleFormProps = {
  article: ArticleType | null
}

type FormValues = { name: string; description: string; users: string[] }

export const FormArticle = ({ article }: ArticleFormProps) => {
  const { Item } = Form
  const { TextArea } = Input
  const { Title, Paragraph, Text } = Typography
  const { allUserBudgetMap } = useUsers()
  const options = [...allUserBudgetMap]
    .map(([value, label]) => ({ value, label }))
    .sort((first, second) =>
      first.label.localeCompare(second.label, 'ru', { sensitivity: 'base' }),
    )
  const [form] = Form.useForm()

  const initialValues = {
    name: article ? article.name : '',
    description: article ? article.description : '',
    users: article ? article.users : [],
  }

const handleCancel = () => closeModalArticle()

const handleSubmit = (values: FormValues) => {
  const payload = {
    ...values,
    name: values.name.trim(),
    description: values.description.trim(),
  }

  if (article) {
    submitUpdateArticle({ ...payload, articleId: article.articleId })
  } else {
    submitAddArticle(payload)
  }

  closeModalArticle()
}

  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit}
      form={form}
      initialValues={initialValues}
    >
      <Item
        required={false}
        label={
          <Text>
            <Title level={4} style={{ marginBottom: 8 }}>
              Общая информация
            </Title>
            <Paragraph style={{ marginBottom: 8 }} type="secondary">
              {HELP_TEXT_GENERAL}
            </Paragraph>
            <UiText size={18} type="secondary">
              Название статьи *
            </UiText>
          </Text>
        }
        name="name"
        rules={[
          {
            required: true,
            message: REQUIRED_FIELD,
          },
        ]}
      >
        <Input />
      </Item>
      <Item
        required={false}
        label={
          <UiText size={18} type="secondary">
            Описание <Text>*</Text>
          </UiText>
        }
        name="description"
        rules={[
          {
            required: true,
            message: REQUIRED_FIELD,
          },
        ]}
      >
        <TextArea rows={6} />
      </Item>
      <ItemSelectUsers
        form={form}
        name="users"
        options={options}
        label={
          <Text>
            <Title level={4} style={{ marginBottom: 8 }}>
              Кому доступна{' '}
            </Title>
            <Paragraph
              style={{ fontSize: 14, marginBottom: 8 }}
              type="secondary"
            >
              {HELP_TEXT_PERMISSIONS}
            </Paragraph>
            <UiText size={18} type="secondary">
              Сотрудники *
            </UiText>
          </Text>
        }
      />
      <Flex gap={8}>
        <Button style={{ flex: 1 }} size="large" onClick={handleCancel}>
          Отменить
        </Button>
        <Button
          style={{ flex: 1 }}
          type="primary"
          size="large"
          htmlType="submit"
        >
          {article ? 'Сохранить' : 'Добавить'}
        </Button>
      </Flex>
    </Form>
  )
}
